<template>
    <div class="bg-v2-white min-w-80 relative w-[30vw] h-full overflow-y-auto dark:bg-v2-gray-50">
        <loading-progress :is-loading="exporting" class="loading-progress">
            <Transition :name="animation">
                <!--
                This is the new version of the "you are in a single tray" view. The old version is
                commented out (much) farther below.
                -->
                <PinsShow v-if="drawer.selected_tray" />
                <!--
                This is the new version of the default / "home" view. The old version is commented
                out (much) farther below.
                -->
                <PinsIndex v-else />
            </Transition>
        </loading-progress>
    </div>
</template>

<script setup>
import { LoadingProgress, PinsShow, PinsIndex } from '@/Components';
import { usePinsDrawer, usePinSearch, eventBus } from '@/Composables';
import {computed, ref, onMounted, onUnmounted, watch} from 'vue';

//COMPOSABLES
const {drawer, fetchTrays} = usePinsDrawer();

//REFS
const dropdown = ref(null);
const performing_search = ref(false);
const is_fetching_trays = ref(false);
const exporting = ref(false);

//COMPUTED
const animation = computed(() => drawer.value?.selected_tray ? 'slide-left' : 'slide-right');

//FUNCTIONS
function onTraysFetched(trays) {
    is_fetching_trays.value = false;
}

function onTrayCreated(tray) {
    is_fetching_trays.value = true;
    fetchTrays()
}

function onTrayUpdated(tray) {
    is_fetching_trays.value = true;
    fetchTrays()
}

function onTrayExporting(exporting_status) {
    exporting.value = exporting_status;
}

const { searchIsLoading } = usePinSearch(true);

//ONMOUNTED
onMounted(() => {
    eventBus.on('pins:trays-fetched',onTraysFetched);
    eventBus.on('pins:tray-created',onTrayCreated);
    eventBus.on('pins:tray-updated',onTrayUpdated);
    eventBus.on('pins:tray-exporting',onTrayExporting);
    is_fetching_trays.value = true;
    fetchTrays()
});

//ONUNMOUNTED
onUnmounted(() => {
    eventBus.off('pins:trays-fetched',onTraysFetched);
    eventBus.off('pins:tray-created',onTrayCreated);
    eventBus.off('pins:tray-updated',onTrayUpdated);
    eventBus.off('pins:tray-exporting',onTrayExporting);
});

//WATCH
watch(searchIsLoading,(is_loading) => {
    if(is_loading)
        setTimeout(() => performing_search.value = false, 200)
});

</script>


<style>
.loading-progress,
.loading-progress > div {
    @apply h-full;
}

.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
    transition: all .2s ease-out;
    position: absolute;
    width: 100%;
    overflow: hidden;
}

.slide-right-leave-to,
.slide-left-enter-from {
    transform: translateX(100%);
    overflow: hidden;
}

.slide-right-enter-from,
.slide-left-leave-to {
    transform: translateX(-100%);
    overflow: hidden;
}
</style>
